// src/constants/colors.js
export const COLORS = {
  // ===== COULEURS PRINCIPALES =====
  primary: '#055697',
  primaryDark: '#055697',
 secondary: '#C42625',
  secondaryDark: '#8f1a1a',
  secondaryLight: '#e85050',
  gradientSecondary: 'linear-gradient(135deg, #C42625 0%, #8f1a1a 100%)',
   secondaryRedLight: 'rgba(196, 38, 37, 0.1)',

  // ===== COULEURS SÉMANTIQUES =====
  success: '#10b981',
  successLight: 'rgba(16, 185, 129, 0.1)',
  danger: '#ef4444',
  dangerLight: 'rgba(239, 68, 68, 0.1)',
  warning: '#f59e0b',
  warningLight: 'rgba(245, 158, 11, 0.1)',
  info: '#3b82f6',
  infoLight: 'rgba(59, 130, 246, 0.1)',

  // ===== COULEURS POUR LES GRAPHIQUES ET STATISTIQUES =====
  purple: '#8b5cf6',
  purpleLight: 'rgba(139, 92, 246, 0.1)',
  pink: '#ec4899',
  pinkLight: 'rgba(236, 72, 153, 0.1)',
  indigo: '#6366f1',
  indigoLight: 'rgba(99, 102, 241, 0.1)',
  cyan: '#06b6d4',
  cyanLight: 'rgba(6, 182, 212, 0.1)',
  rose: '#f43f5e',
  roseLight: 'rgba(244, 63, 94, 0.1)',
  emerald: '#059669',
  emeraldLight: 'rgba(5, 150, 105, 0.1)',
  amber: '#d97706',
  amberLight: 'rgba(217, 119, 6, 0.1)',
  teal: '#14b8a6',
  tealLight: 'rgba(20, 184, 166, 0.1)',
  sky: '#0ea5e9',
  skyLight: 'rgba(14, 165, 233, 0.1)',
  violet: '#7c3aed',
  violetLight: 'rgba(124, 58, 237, 0.1)',
  fuchsia: '#d946ef',
  fuchsiaLight: 'rgba(217, 70, 239, 0.1)',
  orange: '#f59e0b',
  orangeLight: 'rgba(245, 158, 11, 0.1)',
  gray: '#6b7280',
  grayLight: 'rgba(107, 114, 128, 0.1)',

  // ===== DÉGRADÉS =====
  gradient: 'linear-gradient(135deg, #1DACCE 0%, #3EA436 100%)',
  gradientBlue: 'linear-gradient(135deg, #1DACCE 0%, #1787a3 100%)',
  gradientGreen: 'linear-gradient(135deg, #3EA436 0%, #2d7a28 100%)',

  // ===== NEUTRES =====
  white: '#FFFFFF',
  lightGray: '#F8F9FA',
  dark: '#1E293B',
  textGray: '#64748B'
};